var _style, _polygon, _polygon2, _path, _path2, _polygon3, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundcube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "9.14 141.8 573.65 573.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#404F54;}\n.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#E5E5E5;}\n.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#CCCCCC;}\n.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#37BEFF;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "582.79,549.77 295.96,384.1 295.96,207.27 582.79,372.95 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.14,549.77 295.96,384.1 295.96,207.27 9.14,372.95 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M295.96,141.8c109.56,0,198.41,88.85,198.41,198.41c0,109.56-88.85,198.41-198.41,198.41 c-109.56,0-198.41-88.85-198.41-198.41C97.55,230.65,186.4,141.8,295.96,141.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.96,141.8c109.6,0,198.48,88.85,198.48,198.41c0,109.56-88.88,198.41-198.48,198.41 c-62.91-42.34-88.94-127.64-88.94-198.3S233.05,184.22,295.96,141.8"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "582.79,372.95 295.96,538.62 295.96,715.45 582.79,549.77 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.14,372.95 295.96,538.62 295.96,715.45 9.14,549.77 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundcube);
export default __webpack_public_path__ + "static/media/roundcube.f007ddc52ce72a6a3e5ddf8d65cadabe.svg";
export { ForwardRef as ReactComponent };